// removed by extract-text-webpack-plugin
module.exports = {"group":"src-components-Search----search-module---group---692xI","label":"src-components-Search----search-module---label---3-C-S","input":"src-components-Search----search-module---input---1j0Y0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/search.module.scss
// module id = 263
// module chunks = 35783957827783